import { isIOS } from "@memorang/helpers/src/common";
import Constants from "expo-constants";
import type { RelativePathString } from "expo-router";

export const createRelativeURL = (
	path: string,
	params: Record<string, string | number | boolean>,
) => {
	let url = path;
	const queryParams = Object.entries(params)
		.filter(([, value]) => value !== undefined)
		.map(([key, value]) => `${encodeURIComponent(key)}=${value}`)
		.join("&");

	if (queryParams) {
		url += `?${queryParams}`;
	}

	return url as RelativePathString;
};

export const getStoreUrl = () => {
	const iosUrl = Constants.expoConfig?.ios?.appStoreUrl;
	const androidUrl = Constants.expoConfig?.android?.playStoreUrl;
	const url = isIOS ? iosUrl : androidUrl;
	return url;
};
